
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexgPMh34d7GGlJjWWQ_45ttWxTIVbc26EhZ5MEtr5BoKFQUMeta } from "/home/circleci/project/pages/index.vue?macro=true";
import { default as legaldCgJGWJU02poyQzYbSybBvVF_45_45qNNvy6LPcPo54sftAMeta } from "/home/circleci/project/pages/legal.vue?macro=true";
import { default as credits_455u1r2ODM0E025iihCGB43mg7v30mfzPbbR_45V4voQ6oMeta } from "/home/circleci/project/pages/credits.vue?macro=true";
import { default as privacy0dgrCKlY39OXj5xfQbkqgoWzl4QojYa42MJDj9iLcEMMeta } from "/home/circleci/project/pages/privacy.vue?macro=true";
import { default as _91_46_46_46slug_93VGeg3VnRoDdroOdQ2bBCR_45g4uZmqG0dMU46RN3p2azQMeta } from "/home/circleci/project/pages/[...slug].vue?macro=true";
import { default as iba_45noticesVdCN5dsWgaGBuVo8Nirb_45rB5di5mOFIro8BS4D_t29kMeta } from "/home/circleci/project/pages/iba-notices.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/circleci/project/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/home/circleci/project/pages/legal.vue")
  },
  {
    name: "credits",
    path: "/credits",
    component: () => import("/home/circleci/project/pages/credits.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/circleci/project/pages/privacy.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93VGeg3VnRoDdroOdQ2bBCR_45g4uZmqG0dMU46RN3p2azQMeta || {},
    component: () => import("/home/circleci/project/pages/[...slug].vue")
  },
  {
    name: "iba-notices",
    path: "/iba-notices",
    component: () => import("/home/circleci/project/pages/iba-notices.vue")
  }
]